import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IPaymentState } from 'Redux/Slices/Payment/PaymentSlice';

type TPayload = { paymentMethod: string };

export const setPaymentMethod = (state: Draft<IPaymentState>, { payload }: PayloadAction<TPayload>) => {
  state.paymentMethod = payload.paymentMethod;
  state.updatedAt = Date.now();
};
